import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ArrowRight, Lock } from "lucide-react";

const PLAYABLE = new Set([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);

export default function SessionsList() {
  const [sessions, setSessions] = useState([]);
  const [progress, setProgress] = useState([]);

  useEffect(() => {
    api.get("/sessions").then((r) => setSessions(r.data));
    api.get("/progress/me").then((r) => setProgress(r.data.sessions || []));
  }, []);

  const groups = sessions.reduce((acc, s) => {
    acc[s.module] = acc[s.module] || { title: s.module_title, sessions: [] };
    acc[s.module].sessions.push(s);
    return acc;
  }, {});

  return (
    <div className="space-y-10" data-testid="sessions-list">
      <div>
        <p className="text-sm uppercase tracking-widest text-primary font-semibold">Programa completo</p>
        <h1 className="heading text-4xl font-extrabold mt-1">20 sesiones estructuradas</h1>
        <p className="text-lg text-foreground/70 mt-2 max-w-2xl">
          Cuatro módulos, 400 ejercicios originales. Empieza por la Sesión 1 (emociones básicas) o Sesión 5 (mentalización).
        </p>
      </div>

      {Object.entries(groups).map(([mod, g]) => (
        <div key={mod}>
          <h2 className="heading text-xl font-bold mb-3">{g.title}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {g.sessions.map((s) => {
              const prog = progress.find((p) => p.session_id === s.id) || {};
              const playable = PLAYABLE.has(s.id);
              return (
                <Card key={s.id} className="rounded-2xl border-border" data-testid={`session-item-${s.id}`}>
                  <CardHeader>
                    <div className="flex items-center justify-between">
                      <Badge variant="outline" className="text-xs">Sesión {s.id}</Badge>
                      {!playable && <Badge variant="secondary" className="text-xs"><Lock size={10} className="mr-1" /> Beta</Badge>}
                    </div>
                    <CardTitle className="heading text-lg mt-2">{s.title}</CardTitle>
                    <CardDescription>{s.description}</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="text-xs text-muted-foreground mb-3">
                      {prog.completed_exercises || 0}/{s.exercise_count} ejercicios · {s.duration_min || 40} min
                    </div>
                    {playable ? (
                      <Link to={`/sessions/${s.id}`}>
                        <Button size="sm" className="rounded-full" data-testid={`open-session-${s.id}`}>
                          Abrir <ArrowRight size={14} className="ml-1" />
                        </Button>
                      </Link>
                    ) : (
                      <Button size="sm" variant="outline" className="rounded-full" disabled>Próximamente</Button>
                    )}
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
